import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FaFilePdf, FaDownload, FaEye, FaCalendarAlt, FaChartLine, FaBookOpen } from "react-icons/fa";
import annual from "../Assests/annual.png";
import CommonBanner from "../Components/Common";

import examplePDF from "./New_Annual _Report-23-24.pdf";
import examplePDF2 from "./New_Annual_Report-22-23.pdf";
import examplePDF3 from "./New_Annual_Report-24-25.pdf";
import examplePDF26 from "./Annual_report_25_26.pdf";

import "./AnnualReport.css";
import { useNavigate } from "react-router-dom";

const Annual = () => {
  const [loading, setLoading] = useState({});
  const navigate = useNavigate();
  const handleViewPDF = (pdf, name) => {
    setLoading(prev => ({ ...prev, [name]: true }));
    window.open(pdf, "_blank");
    setTimeout(() => {
      setLoading(prev => ({ ...prev, [name]: false }));
    }, 1000);
  };

  const handleDownloadPDF = (pdf, name) => {
    const link = document.createElement("a");
    link.href = pdf;
    link.download = `${name}.pdf`;
    link.click();
  };

  const reports = [
    {
      id: "2025-2026",
      year: "2025 - 2026",
      title: "Annual Report 2025-2026",
      description: "A detailed account of our initiatives, community outreach, and financial transparency for the fiscal year 2025-2026",
      pdf: examplePDF26,
      icon: FaChartLine,
      color: "#F56A01",
      highlights: [
        "Free Bone and Joint Checkup Camps",
        "Free Medicine Distribution Initiative",
        "Blanket Distribution",
        "Free Funeral Feast"
      ],
      pageCount: "20 Pages",
      fileSize: "3.8 MB"
    },
    {
      id: "2024-2025",
      year: "2024 - 2025",
      title: "Annual Report 2024-2025",
      description: "Comprehensive report of our activities, achievements, and impact during the fiscal year 2024-2025",
      pdf: examplePDF3,
      icon: FaChartLine,
      color: "#F56A01",
      highlights: [
        "5000+ Beneficiaries Served",
        "15+ Major Events",
        "New Educational Initiatives",
        "Community Development Programs"
      ],
      pageCount: "48 Pages",
      fileSize: "2.5 MB"
    },
    {
      id: "2023-2024",
      year: "2023 - 2024",
      title: "Annual Report 2023-2024",
      description: "Detailed overview of our programs, financials, and community impact for 2023-2024",
      pdf: examplePDF,
      icon: FaBookOpen,
      color: "#F56A01",
      highlights: [
        "4500+ Beneficiaries Served",
        "12+ Major Events",
        "Healthcare Camps",
        "Women Empowerment Programs"
      ],
      pageCount: "52 Pages",
      fileSize: "2.8 MB"
    },
    {
      id: "2022-2023",
      year: "2022 - 2023",
      title: "Annual Report 2022-2023",
      description: "Year-end summary of accomplishments, financial statements, and future goals",
      pdf: examplePDF2,
      icon: FaCalendarAlt,
      color: "#F56A01",
      highlights: [
        "4000+ Beneficiaries Served",
        "10+ Major Events",
        "Educational Support",
        "Rural Development"
      ],
      pageCount: "44 Pages",
      fileSize: "2.3 MB"
    }
  ];

  return (
    <>
      <CommonBanner image={annual} />

      <div className="annual-report-page">
        <Container>
          {/* Header Section */}
          <div className="report-header">
            <div className="header-badge">
              <FaFilePdf className="badge-icon" />
              <span>Annual Reports</span>
            </div>
            <h1 className="report-title">
              Our <span className="highlight">Annual Reports</span>
            </h1>
            <p className="report-subtitle">
              Explore our journey, achievements, and impact through comprehensive annual reports
            </p>
            <div className="header-decoration">
              <span className="decoration-line"></span>
              <span className="decoration-diamond">✦</span>
              <span className="decoration-line"></span>
            </div>
          </div>

          {/* Reports Grid - 3 Cards in One Row */}
          <Row className="reports-grid">
            {reports.map((report, index) => (
              <Col lg={4} md={6} sm={12} key={report.id} className="mb-4">
                <div className="report-card" style={{ animationDelay: `${index * 150}ms` }}>
                  <div className="card-glow" style={{ background: `radial-gradient(circle at 50% 50%, ${report.color}20, transparent)` }}></div>

                  {/* Year Badge */}
                  <div className="year-badge" style={{ background: `linear-gradient(135deg, ${report.color}, ${report.color}dd)` }}>
                    <span>{report.year}</span>
                  </div>

                  {/* Icon */}
                  <div className="icon-wrapper" style={{ background: `linear-gradient(135deg, ${report.color}, ${report.color}dd)` }}>
                    <report.icon className="report-icon" />
                  </div>

                  <h2 className="report-title-card">{report.title}</h2>
                  <p className="report-description">{report.description}</p>

                  {/* Highlights */}
                  <div className="highlights-section">
                    <h4 className="highlights-title">Key Highlights</h4>
                    <div className="highlights-list">
                      {report.highlights.map((highlight, idx) => (
                        <div key={idx} className="highlight-item">
                          <span className="highlight-bullet">▸</span>
                          <span>{highlight}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* File Info */}
                  <div className="file-info">
                    <span className="file-detail">
                      <strong>Pages:</strong> {report.pageCount}
                    </span>
                    <span className="file-detail">
                      <strong>Size:</strong> {report.fileSize}
                    </span>
                  </div>

                  {/* Action Buttons */}
                  <div className="card-actions">
                    <Button
                      variant="outline"
                      className="action-btn view-btn"
                      style={{ borderColor: report.color, color: report.color }}
                      onClick={() => handleViewPDF(report.pdf, report.id)}
                      disabled={loading[report.id]}
                    >
                      {loading[report.id] ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2"></span>
                          Loading...
                        </>
                      ) : (
                        <>
                          <FaEye className="btn-icon" />
                          View Report
                        </>
                      )}
                    </Button>

                    <Button
                      className="action-btn download-btn"
                      style={{ background: `linear-gradient(135deg, ${report.color}, ${report.color}dd)` }}
                      onClick={() => handleDownloadPDF(report.pdf, report.title)}
                    >
                      <FaDownload className="btn-icon" />
                      Download PDF
                    </Button>
                  </div>
                </div>
              </Col>
            ))}
          </Row>

          {/* Info Section */}
          <div className="info-section">
            <div className="info-content">
              <h3>Why Review Our Annual Reports?</h3>
              <div className="info-grid">
                <div className="info-card">
                  <div className="info-icon">📊</div>
                  <p>Transparent financial reporting</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">🎯</div>
                  <p>Program impact measurement</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">📈</div>
                  <p>Growth and achievements</p>
                </div>
                <div className="info-card">
                  <div className="info-icon">🤝</div>
                  <p>Donor accountability</p>
                </div>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="cta-section">
            <h4>Support Our Mission</h4>
            <p>Your contribution helps us create lasting impact in communities</p>
            <Button className="cta-button" onClick={() => navigate("/whydonation")}>
              Donate Now
            </Button>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Annual;